import { DataBean } from "../DataBean";

export class FactorNameList extends DataBean {


    public async getPayrollFactorNameList(year:any,valueType:any,fortnightType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollFactorNameList_Number_Number_Number", [year,valueType,fortnightType]);
    }
   

    

 
}